<template>
  <div id="tab2" class="row" v-if="this.$parent.activeTab === 2">
    <div class="col-md-12 col-sm-12 mb-3">
      <label for="warehouse-name" class="form-label">საწყობი</label>
      <v-select
          v-model="this.$parent.warehouse"
          label="name"
          id="filter-wr-name"
          :class="{'select-is-invalid': this.$parent.v$.warehouse.$error}"
          :options="this.$parent.warehouses.list"
          placeholder="აირჩიეთ საწყობი"
          @option:selected="onChangeWarehouse"
      >
        <template v-slot:no-options>სია ცარიელია</template>
      </v-select>
      <div class="invalid-feedback" v-if="this.$parent.v$.warehouse.$error">
        {{ this.$parent.v$.warehouse.$errors[0]?.$message }}
      </div>
    </div>
    <div v-if="this.$parent.warehouse?.id != -1" class="col-6 mb-3">
      <label for="room-name" class="form-label">ოთახი</label>
      <v-select v-model="this.$parent.selectedRoom" label="name" id="room-name" :options="this.$parent.rooms"
                :class="{'select-is-invalid': this.$parent.v$.selectedRoom.$error}"
                placeholder="აირჩიეთ ოთახი"
                @option:selected="onChangeRooms"
      >
        <template v-slot:no-options>სია ცარიელია</template>
      </v-select>
      <div class="invalid-feedback" v-if="this.$parent.v$.selectedRoom.$error">
        {{ this.$parent.v$.selectedRoom.$errors[0]?.$message }}
      </div>
    </div>

    <div v-if="this.$parent.warehouse?.id == -1">
      <label for="sensors-name" class="form-label">სენსორი</label>


      <v-select v-model="this.$parent.selectedSensors" label="name" id="sensors-name" multiple
                placeholder="აირჩიეთ სენსორი"
                :options="this.sensors"
                :class="{'select-is-invalid': this.$parent.v$.selectedSensors.$error}"
      >
        <template v-slot:no-options>სია ცარიელია</template>
      </v-select>
      <div class="invalid-feedback" v-if="this.$parent.v$.selectedSensors.$error">
        {{ this.$parent.v$.selectedSensors.$errors[0]?.$message }}
      </div>
    </div>

    <div v-if="this.$parent.alertType !== 15 && this.$parent.warehouse?.id != -1" class="col-6 mb-3">
      <label for="sensor-name" class="form-label">სენსორი</label>
      <v-select v-model="this.$parent.selectedSensor" label="name" id="sensor-name" :options="this.$parent.sensors"
                :class="{'select-is-invalid': this.$parent.v$.selectedSensor.$error}"
                placeholder="აირჩიეთ სენსორი"
                :item-text="sensor"
      >
        <template v-slot:option="sensor">
          {{ sensor.name }} {{
            sensor.description !== null && sensor.description !== "" && typeof sensor.description !== "undefined" ? `- ${sensor.description} ` : ''
          }}
        </template>
        <template v-slot:no-options>სია ცარიელია</template>
      </v-select>
      <div class="invalid-feedback" v-if="this.$parent.v$.selectedRoom.$error">
        {{ this.$parent.v$.selectedSensor.$errors[0]?.$message }}
      </div>
    </div>

  </div>
</template>

<script>
import KSelect from "@/components/custom/KSelect.vue";

export default {
  name: "Tab2",
  components: {KSelect},
  data() {
    return ({
      sensors: [
        {name: "1", id: 1, imei: "empty", index: 1},
        {name: "2", id: 2, imei: "empty", index: 2},
        {name: "3", id: 3, imei: "empty", index: 3},
        {name: "4", id: 4, imei: "empty", index: 4},
        {name: "5", id: 5, imei: "empty", index: 5},
        {name: "6", id: 6, imei: "empty", index: 6},
        {name: "7", id: 7, imei: "empty", index: 7},
        {name: "8", id: 8, imei: "empty", index: 8}
      ]
    })
  },
  computed:{
    options(){
    }
  },
  methods:{
    onChangeWarehouse(element) {
      if (element.id > -1)
      this.$store.dispatch('warehouse/getWarehouseRooms', element.id).then(
          () => {
            this.sensors = null
          }
      )
    },
    onChangeRooms(element) {
      this.$store.dispatch('warehouse/getWarehouseRoomSensors', element.id).then(
          () => {
          }
      )
    },
  }
}
</script>